import { storage, cloudFunction } from '../../config/firebaseConfig';

//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 1 => HANDLE CURRENT PROJECT DATA
///
export const setCurrentFloorId = (floorid) => {
    return {
        type: "SET_CURRENT_FLOOR_ID",
        floorid,
    }
}

export const clearFloorId = () => {
    return {
        type: "CLEAR_FLOOR_ID",
    }
}

export const setCurrentElevationMeta = (elevationMeta) => {
    return {
        type: "SET_CURRENT_ELEVATION_META",
        elevationMeta,
    }
}

//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 2 => NEW PART CREATION AND UPDATES
///
export const openNewFloorModal = () => {
    return {
        type: "OPEN_NEW_FLOOR_MODAL",
    }
}

export const createFloor = (proid, name, fileName, containsMap) => {
    return async (dispatch, getState, { getFirestore }) => {
        /// dispatch to indicate part creation started
        dispatch({ type: "ADD_NEW_FLOOR" });

        // async call to upload new shape
        const firestore = getFirestore();

        // generate id
        const newFloorid = firestore.collection(`Projects/${proid}/Markers`).doc().id;

        // update floorsMap with new floor
        await firestore.collection('Projects').doc(proid).update({
            [`floorsMap.${newFloorid}`]: {
                floorid: newFloorid,
                name: `${name}` ?? "",
                dateCreated: firestore.FieldValue.serverTimestamp(),
                fileName: `${fileName}` ?? "",
                proid: proid,
                containsMap: containsMap,
            },
        });

        /// finally dispatch success action
        return dispatch({
            type: "NEW_FLOOR_ADDED",
            floorid: newFloorid,
        });
    };
}

export const openArchiveFloorFromProjectModal = () => {
    return {
        type: "FAPI_CALL_RESET",
    }
}

export const archiveFloorFromProject = (userModelJson, projectModelJson, floorMapJson) => {
    return async (dispatch, getState) => {
        // console.log(userModelJson, projectModelJson, floorMapJson)
        /// dispatch to indicate initiation of request
        dispatch({
            type: "FAPI_CALL_INIT",
            fapiMessage: "Please wait while we are processing...",
            showFapiLoader: true,
            fapid: 0,
        });

        cloudFunction.httpsCallable('floor-archiveFloorFromProject')(
            {
                userModelJson,
                projectModelJson,
                floorMapJson,
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "FAPI_CALL_COMPLETED",
                    fapiMessage: res.data.responseMsg,
                    fapiIsDoneAndSent: res.data.isDoneAndSent,
                    showFapiLoader: false,
                    fapid: -1,
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "FAPI_CALL_ERROR",
                    fapiMessage: error,
                    fapiIsDoneAndSent: false,
                    showFapiLoader: false,
                    fapid: -1,
                });
            });
    }
}

//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 3 => ADD FILES UTILS
/// 